import React, { useEffect } from 'react';
import { Button, Input, useToasts } from 'freemium-ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { CustomDomainDetailsType } from '../../../../../../shared/types';
import Icon from '../../../../../../shared/components/Icon';
import Spacer from '../../../../../../shared/components/Spacer';
import { useAddCustomDomain, useRemoveCustomDomain } from '../../../hooks';
import { Label, VerifyAdornment } from '../../../styles';
import { Adornment } from '../styles';

const GenerateCname = ({
  setCnameStates,
  isCnameGenerated,
  isCnameVerified,
  accountInfo,
  handleCnameRemove,
}: any) => {
  const { t } = useTranslation();
  const [, setToast] = useToasts();
  const { mutate: addCustomDomain, isLoading: isLoadingAddCustomDomain } =
    useAddCustomDomain({
      setToast,
      callback: (isSuccess: boolean, response: CustomDomainDetailsType) => {
        if (isSuccess && !response?.error) {
          setCnameStates(response?.status);
        }
      },
    });
  const { mutate: removeCustomDomain, isLoading: isLoadingRemoveCustomDomain } =
    useRemoveCustomDomain({
      setToast,
      callback: (isSuccess: boolean, response: CustomDomainDetailsType) => {
        if (isSuccess && !response?.error) {
          setCnameStates(response?.status);
          handleCnameRemove();
        }
      },
    });
  const urlRegex =
    /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{0,61}[a-z]/i;

  const form = useForm({
    resolver: yupResolver(
      Yup.object({
        custom_domain: Yup.string()
          .trim()
          .matches(urlRegex, 'Enter a valid url'),
      }).required(),
    ),
    defaultValues: {
      custom_domain: '',
    },
  });
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { isDirty, errors },
  } = form;
  const custom_domain = watch('custom_domain');

  const onSubmit = (data: any) => {
    addCustomDomain(data);
  };

  const onRemove = () => {
    removeCustomDomain();
  };

  useEffect(() => {
    setValue('custom_domain', accountInfo?.custom_domain);
  }, [accountInfo]);

  return (
    <form>
      <div className="inline">
        <Input
          placeholder="custom.domain.com"
          startAdornment={<Adornment position="start">https://</Adornment>}
          endAdornment={
            isCnameVerified ? (
              <VerifyAdornment>{t('verififed')}</VerifyAdornment>
            ) : (
              isCnameGenerated && (
                <Label type="pending">
                  {t('settings.custom_domain.verification_pending')}
                </Label>
              )
            )
          }
          errorText={errors?.custom_domain?.message}
          isErrored={Boolean(errors.custom_domain?.message)}
          {...register('custom_domain')}
          disabled={accountInfo.status !== 'ACTIVATED' || isCnameVerified}
        />
      </div>
      <Spacer y={1} />
      {isCnameGenerated || isCnameVerified ? (
        <Button
          inline
          type="secondary"
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            onRemove();
          }}
          disabled={isLoadingRemoveCustomDomain}
        >
          <Icon glyph="delete" fill="none" width="12" height="12" />
          &nbsp;{t('settings.custom_domain.remove_cname')}
        </Button>
      ) : (
        <Button
          id="generate-cname-btn"
          inline
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            handleSubmit(onSubmit, (err) => console.log('ERR', err))();
          }}
          disabled={
            Boolean(errors.custom_domain) ||
            isLoadingAddCustomDomain ||
            accountInfo.status !== 'ACTIVATED' ||
            !custom_domain
          }
        >
          {t('settings.custom_domain.generate_cname')}
        </Button>
      )}
    </form>
  );
};
export default GenerateCname;
